import React, { useState } from "react";
import { Checkbox, ActionButton, Icon, TextField } from "@fluentui/react";
import { KnowledgeBase, MarketplaceOffer, OfferStatus } from "@the-real-insight/tri-model";
import { userAPI } from "../UserAPI";
import { useModalContext } from "../components/ModalProvider";
import { useAtom } from "jotai";
import { authenticationAtom } from "../State";

interface OfferStatusManagementProps {
    marketplaceOffer: KnowledgeBase | MarketplaceOffer;
    updateSelectedMarketplaceOffer: (knowledgeBase: any) => void;
}

export default function OfferStatusManagement({
    marketplaceOffer,
    updateSelectedMarketplaceOffer
}: OfferStatusManagementProps) {
    const [authentication] = useAtom(authenticationAtom) as any;
    const { pushError, showDeleteDialog } = useModalContext() as any;
    const [appealReason, setAppealReason] = useState('');

    return (
        <div className="marginTopM displayFlex gapM alignItemsStart">
            <div className="displayFlex flexDirectionColumn gapM">
                <Checkbox
                    label="Intern verfügbar"
                    checked={marketplaceOffer.published}
                    onChange={(e, value) => {
                        const newKnowledgeBase = new KnowledgeBase({ ...marketplaceOffer, published: value });
                        updateSelectedMarketplaceOffer(newKnowledgeBase);
                    }}
                />
                <Checkbox
                    label="Im Marktplatz angeboten"
                    checked={marketplaceOffer.offered}
                    onChange={(e, value) => {
                        const newKnowledgeBase = new KnowledgeBase({ ...marketplaceOffer, offered: value });
                        updateSelectedMarketplaceOffer(newKnowledgeBase);
                    }}
                />
            </div>
            {
                (() => {
                    switch (marketplaceOffer.lastStatus) {
                        case OfferStatus.draft:
                            return (
                                <div>
                                    <ActionButton
                                        iconProps={{ iconName: 'FollowUser' }}
                                        styles={{
                                            root: { color: '#107c10' },
                                            icon: { color: '#107c10' },
                                            label: { color: '#107c10' }
                                        }}
                                        onClick={async () => {
                                            try {
                                                console.log('submitMarketplaceOffer', marketplaceOffer);
                                                const newKnowledgeBase = await userAPI.submitMarketplaceOffer(authentication.customer, marketplaceOffer);
                                                updateSelectedMarketplaceOffer(newKnowledgeBase);
                                            } catch (error) {
                                                pushError(error);
                                            }
                                        }}
                                    >
                                        Angebot zum Review einreichen
                                    </ActionButton>
                                </div>
                            );
                        case OfferStatus.submitted:
                            return (
                                <div className="displayFlex alignItemsCenter gapS colorOrange">
                                    <Icon iconName='Clock' />
                                    Euer Angebot wird gerade geprüft.
                                </div>
                            );
                        case OfferStatus.approved:
                            return (
                                <div>
                                    <div>
                                        Die Lösung ist für den Marktplatz zugelassen.
                                    </div>
                                    <ActionButton
                                        iconProps={{ iconName: 'Rocket' }}
                                        onClick={async () => {
                                            try {
                                                updateSelectedMarketplaceOffer(await userAPI.publishMarketplaceOffer(authentication.customer, marketplaceOffer));
                                            } catch (error) {
                                                pushError(error);
                                            }
                                        }}
                                    >
                                        Angebot im Store veröffentlichen
                                    </ActionButton>
                                </div>
                            );
                        case OfferStatus.published:
                            return (
                                <div>
                                    <div>
                                        Die Lösung ist im Marktplatz verfügbar.
                                    </div>
                                    <ActionButton
                                        iconProps={{ iconName: 'Delete' }}
                                        styles={{
                                            root: { color: '#A4262C' },
                                            icon: { color: '#A4262C' },
                                            label: { color: '#A4262C' }
                                        }}
                                        onClick={async () => {
                                            showDeleteDialog(
                                                'Angebot vom Store entfernen',
                                                'Entfernen',
                                                async () => {
                                                    try {
                                                        updateSelectedMarketplaceOffer(await userAPI.unpublishMarketplaceOffer(authentication.customer, marketplaceOffer));
                                                    } catch (error) {
                                                        pushError(error);
                                                    }
                                                }
                                            );
                                        }}
                                    >
                                        Angebot vom Store entfernen
                                    </ActionButton>
                                </div>
                            );
                        case OfferStatus.rejected:
                            return <div className="displayFlex gapM">
                                <div className="width400">
                                    <div className="displayFlex alignItemsCenter gapS colorRed">
                                        <Icon iconName='Cancel' />
                                        Euer Angebot wurde abgelehnt.
                                    </div>
                                    <div className="marginTopS textS">
                                        <span className="fontWeightBold">Begründung:</span> {marketplaceOffer.rejectionReason}
                                    </div>
                                </div>
                                <div className="width400">
                                    <ActionButton
                                        disabled={!appealReason}
                                        iconProps={{ iconName: 'Edit' }}
                                        onClick={async () => {
                                            try {
                                                updateSelectedMarketplaceOffer(await userAPI.appealAfterOfferRejection(authentication.customer, marketplaceOffer, appealReason));
                                            } catch (error) {
                                                pushError(error);
                                            }
                                        }}
                                    >
                                        Geändertes Angebot erneut einreichen
                                    </ActionButton>
                                    <div>
                                        <TextField
                                            label="Begründung für erneutes Einreichen"
                                            value={appealReason}
                                            multiline
                                            rows={5}
                                            onChange={(e, value) => {
                                                setAppealReason(value || '');
                                            }}
                                        />
                                        <div className="textXS colorGrey">{appealReason.length}/200</div>
                                    </div>
                                </div>
                            </div>;
                        case OfferStatus.discontinued:
                            return (
                                <div className="displayFlex alignItemsCenter gapS colorRed">
                                    <Icon iconName='Archive' />
                                    Dieses Angebot ist nicht mehr verfügbar.
                                </div>
                            );
                        default:
                            return <></>;
                    }
                })()
            }
        </div >
    );
} 